import { render, staticRenderFns } from "./BoxBorder.vue?vue&type=template&id=142c6510&scoped=true&"
import script from "./BoxBorder.vue?vue&type=script&lang=js&"
export * from "./BoxBorder.vue?vue&type=script&lang=js&"
import style0 from "./BoxBorder.vue?vue&type=style&index=0&id=142c6510&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142c6510",
  null
  
)

export default component.exports